import styled from "styled-components";

import { theme } from "../../themes/themes";
export const FrameContainer = styled.div`
  background-color: #f2f2f2;
  border-radius: 8px;
  height: 279px;
  overflow: hidden;
  position: relative;
  width: auto;
  img {
    margin: initial;
    width: 167px;
    margin-top: 39px;
  }
`;
export const LabelText = styled.div`
  text-align: left;
  color: black;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;
  a {
    text-decoration: none;
    color: black;
  }
  .MuiSvgIcon-root {
    font-size: 16px;
    margin-left: 15px;
  }
`;
export const NullValue = styled.div`
  width: 759px;
  height: 344px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #f2f2f2;
`;
export const TextWrapper = styled.div`
  color: ${({ theme }) => theme.text.primary};

  font-size: 24px;
  font-weight: 700;
  height: 17px;
  left: 16px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 23px;
  white-space: nowrap;
`;
export const Image = styled.div`
  width: 195px;
  height: 133px;
  flex-shrink: 0;
  margin-top: -76px;
`;
export const EmptyValue = styled.div`
  .lable1 {
    color: var(--2-e-2-e-2-e, ${({ theme }) => theme.primary.purple});
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: block;
  }
  .lable2 {
    color: var(--2-e-2-e-2-e, ${({ theme }) => theme.primary.purple});
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: block;
  }
`;
export const ContentCenterHorizontal = styled.div`
  display: flex;
  align-items: center;
`;
